import { useState } from "react";
import { PaymentDetails, PaymentOptions } from "../../../common/types";
import { initPaymentOptions } from "../../../common/constants";
import { useTranslation } from "react-i18next";


export const usePaymentApprove = () => {
  const { t } = useTranslation('common');
  const [isScannerOpened, setIsScannerOpened] = useState(false);
  const [paymentOptions, setPaymentOptions] = useState<PaymentOptions[]>([initPaymentOptions]);
  const [isPaymentApproved, setIsPaymentApproved] = useState(false);

  const handlePaymentApprove = (options: PaymentDetails[]) => {
    setPaymentOptions(options.map(option => {
      const { paymentAmount, paymentMethod, authorisationNumber } = option;
      return ({
        paymentAmount: { title: t('approvePayment.paymentAmount'), value: paymentAmount },
        paymentMethod: { title: t('approvePayment.paymentMethod'), value: paymentMethod },
        authorisationNumber: { title: t('approvePayment.authorisationNumber'), value: authorisationNumber || '' }
      } as unknown as PaymentOptions);
    }));
    setIsScannerOpened(true);
  }

  const handleSuccess = () => {
    setIsPaymentApproved(true);
    setIsScannerOpened(false);
  }

  const handleClose = () => {
    setIsScannerOpened(false);
  }
  return { isScannerOpened, paymentOptions, isPaymentApproved, handlePaymentApprove, handleSuccess, handleClose };
};
